// extracted by mini-css-extract-plugin
export default {"main":"Lcatable_main__XcRyU","tablehead":"Lcatable_tablehead__FoVsf","custom-striped-table":"Lcatable_custom-striped-table__h9+a4"};